// extracted by mini-css-extract-plugin
var _1 = "ActivityMobileFiltersDialog_dialog__NkzxL";
var _2 = "ActivityMobileFiltersDialog_dialogFooter__Yg-ov";
export { _1 as "dialog", _2 as "dialogFooter" }
